import { FC } from 'react';
import { Link } from 'ui/links';
import {
  BANNER_MANAGEMENT_SETTINGS_LINK,
  FrequencyManagementUrl,
} from 'modules/frequencyManagement/lib/constants';
import { SupportedMediums } from 'modules/frequencyManagement/lib/types';

export type SummaryBannerProps = {
  messageMedium: SupportedMediums;
};

export const ManageSettingsLink: FC<SummaryBannerProps> = ({ messageMedium }) => {
  return (
    <Link
      hasOpenNewTabIcon
      rel="noopener noreferrer"
      target="_blank"
      href={`${FrequencyManagementUrl}${messageMedium}`}
    >
      {BANNER_MANAGEMENT_SETTINGS_LINK}
    </Link>
  );
};
